<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <router-link to="/">Home</router-link>
        <span class="line">/</span>
        <router-link :to="'/categoria/'+$root._converToURL(product.category_name, product.category_id)">{{product.category_name}}</router-link>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <div v-if="isLoading == false">
      <section class="container oversized-container description-section" id="product-description">
        <div class="row">

          <div class="col-lg-6 col-gallery">
            <swiper :options="galleryOptions">
              <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
                <div class="image-container">
                  <div class="img">
                    <v-zoom :img="row" :width="'100%'"></v-zoom>
                  </div>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>

          <b-form class="col-lg-5 col-description" @submit="addCart">
            <h1 class="name">{{ product.name }}</h1>
            <h6 class="sku">SKU: {{ product.sku }}</h6>
            <h6 class="price discount" v-if="oferta == 1"><span>{{ price_org }}</span></h6>
            <h4 class="price">{{ price }} ({{ product.sales_items_per_unit }} {{ product.sales_unit }})</h4>

            <h6 class="mt-2 subtitle">Descripción</h6>
            <div class="txt-description" v-html="product.description"></div>

            <div class="d-block mt-4 mb-2" v-if="product.pdf">
              <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">Ficha Técnica <i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
            </div>

            <!-- <h6 class="mt-2 mb-1 subtitle" v-if="product.tablaPrecios">Lista de precios</h6>
            <img class="img-fluid" :src="product.tablaPrecios"> -->

            <h6 class="subtitle" v-if="product.color">Color</h6>
            <h4 class="price" v-if="product.color">{{ product.color }}</h4>

            <h6 class="mt-4 mb-1 subtitle" v-if="modelos.length">Presentaciones</h6>
            <b-form-group class="prese-options" v-slot="{ ariaPr }">
              <b-form-radio v-model="modelo" v-for="(row, index) in modelos" :key="index" :value="row.id" :aria-describedby="ariaPr" name="pre">
                <div class="radio-prese">{{ row.name }}</div>
              </b-form-radio>
            </b-form-group>


            <h6 class="mt-4 mb-1 subtitle">Existencias: <b style="color: #1b5985;">{{ product.stock }}</b></h6>
            <br>
            <!-- <div class="table-responsive">
              <table class="table table-sm" id="tablemodels" v-if="product.warehouses.length > 0">
                <thead>
                  <tr>
                    <th class="p-0"></th>
                    <th>Almacen</th>
                    <th>Stock disponible</th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(wareh,indx) in product.warehouses" :key="indx" >
                    <input class="fake-radio" type="radio" :id="'wareh'+indx" :name="wareh.id" :value="wareh.id" v-model="form.warehouses_id">

                    <td>{{wareh.name}}</td>
                    <td>{{wareh.stock}}</td>

                  </tr>
                </tbody>
              </table>
            </div> -->

            <h6 class="mb-1 subtitle" v-if="stock > 0">Cantidad</h6>


            <!-- <b-form-spinbutton id="sb-inline" v-model="form.quantity" inline></b-form-spinbutton> -->

            <!--
              DESCOMENTAR LUEGO -->
              <div class="col-quantity2" v-if="stock > 0">
              <a class="form-control btn-q" @click="changeCantidad('-')">
                <i class="fas fa-minus"></i>
              </a>
              <b-form-input class="input-q" type="number" min="0" v-model="form.quantity" @keypress="isNumber($event)" @paste="noPaste" />
              <a class="form-control btn-q" @click="changeCantidad('+')">
                <i class="fas fa-plus"></i>
              </a>
            </div>
            <div class="col-quantity2" v-else>
              <div class="out-of-stock" style="background-color: #f43c3c;bottom: 10px;color: #fff;font-weight: 500;padding: 4px 14px 5px;right: 0;text-align: center;">Agotado</div>
            </div>



            <div class="d-block mt-4 mb-2" >
              <!-- DESCOMENTAR LUEGO  --><b-button v-if="stock > 0" type="submit" class="my-2 my-xl-0 btn-submit">Agregar al carrito <i class="far fa-shopping-cart"></i></b-button>

              <router-link class="ml-xl-3 my-2 my-xl-0 btn btn-submit btn-contact" :to="{ name: 'contacto', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link>
            </div>

            <hr />

            <div class="col-12 col-comments">
              <b-form class="box-comment" @submit="addComment">
                <h5 class="subt">Califica este producto</h5>

                <div class="box-stars">
                  <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
                </div>

                <div class="box-input">
                  <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                  <p class="mt-2 text-right">
                    <b-button type="submit" class="btn-co">Comentar</b-button>
                  </p>
                </div>
              </b-form>
            </div>

            <div class="col-12 col-extra" id="col-extra">
              <div class="row">
                <!-- <div class="col b-print">
                  <h6>Imprimir</h6>
                  <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
                </div> -->

                <!-- <div class="col px-0 b-sharing">
                  <h6>Compartir</h6>

                  <ShareNetwork
                    v-for="(network, pdInx) in networks"
                    :network="network.network"
                    :key="network.network"
                    :style="{backgroundColor: network.color}"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitterUser="sharing.twitterUser">
                    <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                  </ShareNetwork>

                </div> -->
              </div>
            </div>
          </b-form>

          <!-- <div class="col-11 mx-auto col-extrainfo">
            <div class="row row-info">
              <div class="col-lg-6 col-label">
                <h6>Genero</h6>
              </div>
              <div class="col-lg-6 col-txt" v-html="product.gender"></div>
            </div>

            <div class="row row-info" v-if="product.color">
              <div class="col-lg-6 col-label">
                <h6>Color</h6>
              </div>
              <div class="col-lg-6 col-txt" v-html="product.color.name"></div>
            </div>

            <div class="row row-info">
              <div class="col-lg-6 col-label">
                <h6>Características</h6>
              </div>

              <div class="col-lg-6 col-txt" v-html="product.caracteristicas"></div>
            </div>
          </div> -->

        </div>
      </section>

      <section class="container oversized-container comments-section" v-if="comments.length">
        <div class="row">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>

          <div class="col-12 col-total-comments" v-if="avg > 0">
            <div class="box"><small>TOTAL:</small> {{ avg }}</div>
          </div>

          <div class="col-12 col-comments">
            <div class="row">
              <div class="col-lg-4 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                <div class="box">
                  <div class="box-stars">
                    <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                  </div>

                  <div class="box-comment">{{ item.comment }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="container oversized-container related-products-section" id="related-products">
        <div class="row">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Productos relacionados</h2>
            <hr class="mt-2 mb-2" />
          </div>
        </div>

        <div class="row">
          <div class="col-12 px-0 col-products">
            <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
              <swiper-slide v-for="(product, index) in products" :key="index">
                <div class="col-12 px-0 sample-product">
                  <router-link class="outlined-box" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                    <div class="box-image">
                      <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }">
                        <img src="public/images/shared/empty.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="brand">{{ product.sku }}</h6>
                      <h6 class="name">{{ product.name }}</h6>
                      <h6 class="price">{{ product.price }}</h6>
                    </div>
                    <p class="p-button">
                      <a class="btn-more">Ver más</a>
                    </p>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

      </section>
    </div>
    <div v-else>

        <div class="fa-4x" style="text-align: center;height: 300px;"><i class="fas fa-spinner fa-pulse"></i></div><br/>
    </div>
    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
        </div>
    </sweet-modal>

  </div>
</template>

<script>
import vZoom from 'vue-zoom';
export default {
  components: {vZoom},

  data() {
    return {
      id: null,

      form: {
        modelo: null,
        quantity: 1,
        color: null,
        warehouses_id:null,
      },

      product: [],
      category: [],
      products: [],
      modelos: [],
      modelo:null,
      stock: 0,
      price: 0,
      oferta:null,
      price_org:0,
      avg: 0,

      colors: [],
      gallery: [],
      galleryOld: [],
      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1399: {
            slidesPerView: 5
          },
          1199: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 30,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 20,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },
      isLoading:true,
      // == ==
    }
  },

  watch: {
        "$route.params.id" : function(v){
            //this.id = this.$route.params.id;
            this.id = this.$root._getURLID(this.$route.params.id);
            this.getProduct();
        },

        "modelo" : function(v){
            let model = this.modelos.find( ( model ) => model.id === this.modelo );
            this.price = model.price;
            this.oferta = model.oferta;
            this.price_org = model.price_org;
            this.stock = model.stock;
            this.form.modelo = model.id;

            if(model.images.length > 0){
                this.gallery = model.images;
            }else{
                this.gallery = this.galleryOld;
            }
        },

        'form.quantity' : function(value, oldValue){
          if( value < 1 || value > 100 ){
            setTimeout( ()=>{ this.form.quantity = null; }, 100);
          }
        },
    },

  methods:{
    toast() {
      this.$bvToast.toast(`El producto fue agregado a su carrito`, {
        title: `Producto agregado al carrito`,
        toaster: 'b-toaster-bottom-right b-toaster-custom-1',
        variant: 'success',
        solid: true,
        appendToast: true
      })
    },

    noPaste(evt){
      event.preventDefault();
    },

    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    changeCantidad($type){
      if (this.form.quantity == null) {
        this.form.quantity = 0;
      }
      else{
        this.form.quantity = parseInt(this.form.quantity);
      }

      if ($type == '-') {
        //this.form.quantity = (this.form.quantity > 1) ? --this.form.quantity : 1;
        this.form.quantity = --this.form.quantity ;
      }
      else{
          //this.form.quantity = (this.form.quantity < 100) ? ++this.form.quantity : 100;
          var quantitys = (this.form.quantity + 1);
          if(quantitys > this.product.stock ){

          }
          else{
            this.form.quantity = ++this.form.quantity;
          }
      }
    },

    getProduct(){
      this.isLoading = true;
      axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = [];
        this.gallery = [];
        this.modelo = null;
        this.modelos = [];
        this.product = response.data;
        this.galleryOld = response.data.gallery;
        this.category = response.data.category;

        if(this.product.modelos.length){
            this.modelos = this.product.modelos;
            this.modelo = this.modelos[0].id;
            this.price = this.modelos[0].price;
            this.price_org = this.modelos[0].price_org;
            this.oferta = this.modelos[0].oferta;
            this.stock = this.product.stock;
            this.form.modelo = this.modelos[0].id;

            if(this.modelos[0].images.length > 0){
                this.gallery = this.modelos[0].images;
            }
        }else{
            this.price = this.product.price;
            this.oferta = this.product.oferta;
            this.price_org = this.product.price_org;
            this.stock = this.product.stock;
            this.form.modelo = null;
            this.gallery = response.data.gallery;
        }

        this.isLoading = false;
        this.getRelated(this.id);
        this.getComments(this.id);
      }).catch((error)=>{
        console.log(error);
        this.isLoading = false;
      });
    },

    addCart(evt){
      evt.preventDefault();
      var cart = [];
      var encontrado = false;
      var stockk = 0;
      
      if(this.form.quantity > this.product.stock){

          this.modal.msg = 'El producto <b>'+this.product.name+'</b><br> No cuenta con el suficiente stock';
          this.modal.icon = 'warning';
          this.$refs.modal.open();
          return;
      }
      if(localStorage.cart){
        cart = JSON.parse(localStorage.getItem('cart'));

        for(var i = 0; i < cart.length ; i++){
          if(cart[i].id == this.id && cart[i].modelo == this.form.modelo && cart[i].color == this.form.color){// && this.form.warehouses_id == cart[i].warehouses_id){
            var suma = parseInt(cart[i].quantity) + parseInt(this.form.quantity);
            console.log(suma,this.product.stock);
            if(suma > this.product.stock){
                
                this.modal.msg = 'El producto <b>'+this.product.name+'</b><br> No cuenta con el suficiente stock<br>Actualmente tienes <b>'+cart[i].quantity+'</b> en tu carrito';
                this.modal.icon = 'warning';
                this.$refs.modal.open();
                return;
                break;
            }

            cart[i].quantity = suma;// <= this.stock ? suma : this.stock;
            encontrado = true;
            break;
          }
        }

        if(!encontrado){
          cart.push({ id:this.id, quantity:this.form.quantity, modelo: this.form.modelo, color: this.form.color, imageUrl: this.gallery[0] });
        }
      } else{
        cart.push({ id:this.id, quantity:this.form.quantity, modelo: this.form.modelo, color: this.form.color, imageUrl: this.gallery[0] });
      }
      localStorage.setItem("cart",JSON.stringify(cart));
      this.$root.cartCount = cart.length;
      //this.toast();
      this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito';
      this.modal.icon = 'success';
      this.$refs.modal.open();
    },

    getRelated(id){
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getComments(id){
      axios.get(tools.url('/api/comments/'+id)).then((response)=>{
        this.comments = response.data.comments;
        this.avg = response.data.avg;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addComment: function(){
        axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
            this.comment.stars = null;
            this.comment.body = '';
            this.getComments(this.id);
        }).catch((error) => {
            alert("Error al agregar comentario");
            console.log(error);
        })
    },

    onSubmitComment(event) {
      event.preventDefault();

      if(this.comment.starRating == null){
        alert('Marque las estrellas para calificar este producto.');
      }else{
        // Enviar
        alert('¡Comentario enviado exitosamente!');
      }
    },
    changeWarehouseid(indx,id){

    }

  },

   mounted(){
    //this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();
  }
}
</script>
